import React, { lazy, Suspense } from 'react';
import { styled } from '../../../common.styles';

const LazyFontAwesomeIcon = lazy(() =>
  import('@fortawesome/react-fontawesome').then((m) => ({ default: m.FontAwesomeIcon }))
);

const IconFallback = styled.div`
  background-color: transparent;
  width: 1em;
  height: 1em;
`;

export const LazyFaIcon = (props: any) => (
  <Suspense fallback={<IconFallback className={props.className} />}>
    <LazyFontAwesomeIcon {...props} />
  </Suspense>
);
